import React from "react";
import {connect} from "react-redux";
import {Pagination} from "react-bootstrap";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import {Form, Formik} from "formik";
import {Link} from "react-router-dom";
import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import MenuFiltro, {FiltrosActivos} from "../includes/MenuFiltro";
import CarrouselImages from "./utils/CarrouselImages";
import CarrouselProductosRel from "./utils/CarrouselProductosRel";
import {ModalWhatsappVendedor} from "./utils/ModalWhatsappVendedor";
import {productoActions, utilActions} from "../../_actions";
import {busquedaActions} from "../../_actions/busqueda.actions";
import {
    actualizarMetaTags,
    LoaderGeneral,
    nombreVendedor,
    prepareDataSearch,
    restaurarMetaTags,
    TIPO_REPUESTO_ID
} from "../../_helpers";
import {buscadorService} from "../../_services";
import alertService from "../../_services/cart/alert.service";
import productoServiceTs from "../../_services/cart/producto.service";
import vendedorService from "../../_services/cart/vendedor.service";

/** Cuantas publicaciones se piden para armar el carrusel de destacados. */
const TAMANIO_POZO_DESTACADOS = 24;

/** Cuantas de esas terminan en el carrusel. */
const CANTIDAD_DESTACADOS = 10;

/**
 * Listado de bajas: autos enteros que un desarmadero dio de baja y publica como unidad.
 *
 * <p>Es el mismo endpoint que el listado general (`/public/general/buscar`), fijando el tipo de
 * repuesto en "Baja". El id de ese tipo sale de los filtros que ya trae la pantalla, no de una
 * constante: si alguien renombra o recrea la fila en la tabla, la pantalla lo sigue. La constante
 * queda solo como red de contencion para el primer render, antes de que lleguen los filtros.
 */
class Bajas extends React.Component {

    state = {
        loading: true,
        destacados: [],
        /* Igual que en el Listador: solo cuenta en mobile, para poder cerrar el
         * panel de filtros al elegir uno. */
        filtrosAbiertos: false,
        values: {},
        productoConsulta: undefined,
        ordenadores: [
            {id: "createdDesc", sort: "desc", field: "createdDate", nombre: "Mas nuevos primero"},
            {id: "createdAsc", sort: "asc", field: "createdDate", nombre: "Mas viejos primero"},
            {id: "marcaAsc", sort: "asc", field: "marca.nombre", nombre: "Marca (A-Z)"},
        ],
        pagedSearch: {
            pageSize: 12,
            page: 0,
            search: "",
            orderBy: {id: "createdDesc", sort: "desc", field: "createdDate", nombre: "Mas nuevos primero"},
        },
        data: {},
    };

    componentDidMount() {
        window.scrollTo(0, 0);

        actualizarMetaTags({
            titulo: "Bajas de autos",
            descripcion:
                "Autos dados de baja publicados por desarmaderos homologados de todo el país. " +
                "Filtrá por marca, modelo, versión, zona y vendedor.",
            url: window.location.href,
        });

        /*
         * Sin los filtros no se sabe el id real del tipo "Baja", asi que la primera busqueda
         * espera a que lleguen (la dispara componentDidUpdate). Si ya estaban cargados de otra
         * pantalla, se busca de una.
         */
        if (this.props.filtros === undefined) {
            this.props.traerFiltros();

            return;
        }

        this.buscarData(true, {});
        this.buscarDestacados();
    }

    componentWillUnmount() {
        restaurarMetaTags();
    }

    /** Los filtros recien llegaron: es el momento de la primera busqueda. Ver componentDidMount. */
    componentDidUpdate(prevProps) {
        if (prevProps.filtros === undefined && this.props.filtros !== undefined) {
            this.buscarData(true, this.state.values);
            this.buscarDestacados();
        }
    }

    /** El tipo "Baja" tal como lo conoce la base; sin filtros todavia, el id historico. */
    idTipoBaja = () => {
        const baja = productoActions.buscarBajaObjeto(this.props.filtros?.tipoRepuestos ?? []);

        return baja?.id ?? TIPO_REPUESTO_ID.AUTO_DESARMADERO;
    };

    /** Los filtros del usuario mas el tipo fijo de la pantalla. */
    valoresDeBusqueda = (values) => ({...values, tipoRepuesto: {id: this.idTipoBaja()}});

    buscarImagenes = (prod) => {
        if (prod.imagenes?.length > 0) {
            return prod.imagenes;
        }

        if (prod.productoBaja?.imagenes?.length > 0) {
            return prod.productoBaja.imagenes;
        }

        return [{url: process.env.PUBLIC_URL + "/images/banner-bg.jpg", type: "image/jpeg"}];
    };

    /**
     * Destacados: se pide un pozo de las ultimas bajas y se sortea de ahi en el cliente.
     *
     * <p>El endpoint no sabe devolver filas al azar y no vale la pena que aprenda para esto:
     * lo que se busca es que la franja cambie entre visitas, no un muestreo sobre todo el
     * catalogo.
     */
    buscarDestacados = () => {
        const query = {
            pageSize: TAMANIO_POZO_DESTACADOS,
            page: 0,
            search: "",
            orderBy: {field: "createdDate"},
            orderDirection: "desc",
        };

        buscadorService.buscar(prepareDataSearch(query, "createdDate", "DESC", this.valoresDeBusqueda({}))).then(
            (data) => {
                this.setState({destacados: this.mezclar(data?.results?.content ?? []).slice(0, CANTIDAD_DESTACADOS)});
            },
            // Los destacados son decoracion: si fallan, el listado de abajo sigue sirviendo.
            () => this.setState({destacados: []})
        );
    };

    /** Fisher-Yates sobre una copia. */
    mezclar = (items) => {
        const copia = items.slice();

        for (let i = copia.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copia[i], copia[j]] = [copia[j], copia[i]];
        }

        return copia;
    };

    setOrderBy = (newOrder) => {
        const pagedSearch = {...this.state.pagedSearch, orderBy: newOrder, orderDirection: newOrder.sort, page: 0};

        this.setState({pagedSearch: pagedSearch});
        this.realizarBusqueda(pagedSearch, this.state.values);
    };

    setNewPage = (pageNumber) => {
        const pagedSearch = {...this.state.pagedSearch, page: pageNumber};

        this.setState({pagedSearch: pagedSearch});
        this.realizarBusqueda(pagedSearch, this.state.values);
    };

    buscarData = (nuevaBusqueda, values) => {
        const pagedSearch = nuevaBusqueda ? {...this.state.pagedSearch, page: 0} : this.state.pagedSearch;

        this.setState({values: values, pagedSearch: pagedSearch});
        this.realizarBusqueda(pagedSearch, values);
    };

    realizarBusqueda = (query, values) => {
        this.setState({loading: true});

        buscadorService.buscar(prepareDataSearch(query, "createdDate", "DESC", this.valoresDeBusqueda(values))).then(
            (data) => {
                this.setState({data: data, loading: false});
                this.precargarContactos(data);
            },
            (error) => {
                this.setState({loading: false});
                alertService.error(error);
            }
        );
    };

    /** Mismo motivo que en el listado general: el boton de WhatsApp no puede esperar al fetch. */
    precargarContactos = (data) => {
        const vendedorIds = (data?.results?.content ?? [])
            .map((prod) => prod?.vendedor?.id)
            .filter((id) => !!id);

        if (vendedorIds.length === 0) {
            return;
        }

        vendedorService.precargarContactos(vendedorIds, () => this.setState({recargar: true}));
    };

    renderBotonConsulta = (prod) => {
        if (productoActions.tieneContactosExtra(prod)) {
            return (
                <button
                    className="button"
                    type="button"
                    data-type="message"
                    onClick={() => this.setState({productoConsulta: prod})}
                >
                    <div className="btn--logo">
                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                    </div>
                    <span> Consulta</span>
                </button>
            );
        }

        return (
            <a target="_blank" rel="noreferrer" href={productoActions.crearLinkWhatsapp(prod)}>
                <button className="button" type="button" data-type="message">
                    <div className="btn--logo">
                        <FontAwesomeIcon icon="fa-brands fa-whatsapp" size="lg"/>
                    </div>
                    <span> Consulta</span>
                </button>
            </a>
        );
    };

    renderBanner = () => (
        <header className="bajas__hero">
            <div className="bajas__hero-copy">
                <span className="bajas__hero-kicker">Autos dados de baja</span>
                <h1>Bajas completas, listas para desarmar</h1>
                <p>
                    Unidades enteras publicadas por desarmaderos homologados. Mirá la baja, pedí la
                    pieza que necesitás y coordinás directo con el vendedor.
                </p>
                <ul className="bajas__hero-chips">
                    <li>
                        <FontAwesomeIcon icon="fa-solid fa-shield-halved"/> Vendedores homologados
                    </li>
                    <li>
                        <FontAwesomeIcon icon="fa-solid fa-location-dot"/> Filtrá por zona
                    </li>
                    <li>
                        <FontAwesomeIcon icon="fa-solid fa-screwdriver-wrench"/> Todas sus piezas
                    </li>
                </ul>
            </div>
        </header>
    );

    renderCard = (prod) => (
        <div key={prod.id} className="card__large box-shadow-1">
            <Link
                className="card__large-image"
                to={productoServiceTs.crearUrlProducto(prod)}
                onClick={() => this.props.seleccionarProducto(prod)}
            >
                <div className="card__large-img">
                    <CarrouselImages images={this.buscarImagenes(prod)} esListador={true} esProductDetail={false}/>
                </div>
            </Link>
            <div className="card__large-content">
                <div className="card__large-content--heading">
                    <Link
                        to={productoServiceTs.crearUrlProducto(prod)}
                        onClick={() => this.props.seleccionarProducto(prod)}
                    >
                        <h3>
                            {prod.marca.nombre} {prod.modelo.nombre}
                        </h3>
                    </Link>
                </div>
                <ul>
                    {prod.version?.nombre && <li>{prod.version.nombre}</li>}
                    {prod.anio && <li>Año {prod.anio}</li>}
                    <li>
                        <Link target="_blank" to={vendedorService.crearUrlTienda(prod.vendedor)}>
                            {nombreVendedor(prod.vendedor)}
                        </Link>
                    </li>
                </ul>
            </div>

            <div className="card__large-actions">
                <div className="card__large-stock">
                    {!!prod.vendedor.numeroCelular && this.renderBotonConsulta(prod)}
                </div>
            </div>
        </div>
    );

    render() {
        const {loading, data, ordenadores, destacados} = this.state;
        const {filtros} = this.props;

        const customSelect = {
            control: (provided) => ({
                ...provided,
                background: "transparent",
                borderColor: "transparent",
                height: "25px",
            }),
        };

        return (
            <>
                <div className="container__dap bajas">
                    {this.renderBanner()}

                    {destacados.length > 0 && (
                        <section className="bajas__destacados">
                            <CarrouselProductosRel productos={destacados} nombre="Bajas destacadas"/>
                        </section>
                    )}

                    <Formik
                        enableReinitialize={true}
                        initialValues={this.state.values}
                        onSubmit={(values) => this.buscarData(true, values)}
                    >
                        {({values, setFieldValue, submitForm}) => (
                            <Form>
                                <div className="wrapper">
                                    <div className="filter__container">
                                        <FiltrosActivos
                                            values={values}
                                            filtros={filtros}
                                            setFieldValue={setFieldValue}
                                            submitForm={submitForm}
                                            ocultar={["tipoRepuesto"]}
                                        />
                                        <div className="filterend">
                                            <div className="order_container">
                                                <span>Ordenar por:</span>
                                                <Select
                                                    className="filter_select"
                                                    placeholder="Ordenar Por"
                                                    getOptionLabel={(option) => `${option.nombre}`}
                                                    getOptionValue={(option) => option.id}
                                                    options={ordenadores}
                                                    value={ordenadores.find(
                                                        (option) => option.id === this.state.pagedSearch.orderBy.id
                                                    )}
                                                    onChange={(opt) => this.setOrderBy(opt)}
                                                    components={{IndicatorSeparator: () => null}}
                                                    styles={customSelect}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {["xl"].map((expand) => (
                                        <Navbar
                                            key={expand}
                                            expand={expand}
                                            expanded={this.state.filtrosAbiertos}
                                            onToggle={(abierto) =>
                                                this.setState({filtrosAbiertos: abierto})
                                            }
                                            className="align-items-lg-start filter__menu"
                                        >
                                            <Navbar.Offcanvas
                                                id={`offcanvasBajas-expand-${expand}`}
                                                aria-labelledby={`offcanvasBajasLabel-expand-${expand}`}
                                                placement="start"
                                            >
                                                <Offcanvas.Header closeButton>
                                                    <Offcanvas.Title id={`offcanvasBajasLabel-expand-${expand}`}>
                                                        Filtros
                                                    </Offcanvas.Title>
                                                </Offcanvas.Header>
                                                <Offcanvas.Body>
                                                    <MenuFiltro
                                                        values={values}
                                                        filtros={filtros}
                                                        setFieldValue={setFieldValue}
                                                        submitForm={submitForm}
                                                        ocultarTipoRepuesto={true}
                                                        alAplicar={() =>
                                                            this.setState({filtrosAbiertos: false})
                                                        }
                                                    />
                                                </Offcanvas.Body>
                                            </Navbar.Offcanvas>
                                            <Navbar.Toggle
                                                aria-controls={`offcanvasBajas-expand-${expand}`}
                                                className="button filter__toggle"
                                                data-type="primary-small-alternative"
                                                title="Filtros"
                                            >
                                                <FontAwesomeIcon icon="fa-solid fa-filter"/>
                                                <span>Filtros</span>
                                            </Navbar.Toggle>
                                        </Navbar>
                                    ))}

                                    <main className="result_container">
                                        {loading && <LoaderGeneral grabando={loading}/>}

                                        {!loading && data?.results?.content?.length === 0 && (
                                            <div className="bajas__vacio">
                                                <FontAwesomeIcon icon="fa-solid fa-car-burst" size="2x"/>
                                                <p>No hay bajas cargadas con esos filtros.</p>
                                                <span>Probá quitando alguno o mirá el listado general.</span>
                                                <Link className="button" data-type="primary-small" to="/home">
                                                    Ver todas las publicaciones
                                                </Link>
                                            </div>
                                        )}

                                        {!loading && data?.results?.content?.length > 0 && (
                                            <>
                                                <div className="card__container grid">
                                                    {data.results.content.map((prod) => this.renderCard(prod))}
                                                </div>

                                                <Pagination>
                                                    {utilActions
                                                        .getArrayNumbers(data?.results?.totalPages)
                                                        .map((pageNumber) => (
                                                            <Pagination.Item
                                                                key={pageNumber}
                                                                active={pageNumber === data?.results?.number + 1}
                                                                onClick={() => this.setNewPage(pageNumber - 1)}
                                                            >
                                                                {pageNumber}
                                                            </Pagination.Item>
                                                        ))}
                                                </Pagination>
                                            </>
                                        )}
                                    </main>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>

                {!!this.state.productoConsulta && (
                    <ModalWhatsappVendedor
                        show={!!this.state.productoConsulta}
                        producto={this.state.productoConsulta}
                        handleClose={() => this.setState({productoConsulta: undefined})}
                    />
                )}
            </>
        );
    }
}

function mapState(state) {
    const {filtros} = state.busqueda;
    return {filtros};
}

const actionCreators = {
    traerFiltros: busquedaActions.traerFiltros,
    seleccionarProducto: busquedaActions.seleccionarProducto,
};

const connectedBajas = connect(mapState, actionCreators)(Bajas);
export {connectedBajas as Bajas};
